const Dialer = class {
  constructor(data = {}) {
    this.data = data;
  }

  get dialerAccount() {
    return 'DialerAccount' in this.data ? this.data.DialerAccount : '@';
  }

  get isInPhone() {
    return !this.dialerAccount.includes('@');
  }

  static isValid(data) {
    if (typeof data === 'object' && data !== null) {
      return 'DialerAccount' in data;
    }
    return false;
  }
};

export default Dialer;



// WEBPACK FOOTER //
// ./src/store/models/dialer.js